<template>
    <div class="backdrop">
        <div class="new-item">
            <div style="display:flex;justify-content:center">Report Emailer</div>
            <div style="margin-bottom:10px"><hr class="header-divider"/></div>
            <div style="display:flex;justify-content:space-between; flex-direction: column;flex-wrap: wrap;height:100%">
                <div>
                    Select reports to be emailed daily.
                </div>
                <div class="tenant-input-container">
                    <span>User</span>                    
                     <select v-model="model.userId" @change="isDirty = true" :disabled="users == null">
                        <option v-for="user in users" :key="user.globalId" :value="user.globalId">{{ user.displayName }}</option>
                    </select>
                </div>


                <div class="report-container" v-if="model.reportSelections">
                    <div class="report-header">
                        <span>Report</span>
                        <span>CSV</span>
                        <span>PDF</span>
                    </div>

                    <div class="report-row" v-for="report in model.reportSelections" :key="report.key">
                        <span>{{ report.reportDisplayName }}</span>

                        <input 
                            type="checkbox"
                            :id="`csv-${report.key}`"
                            v-model="report.csv"
                            @click="isDirty = true"
                        />

                        <input :disabled="report.excludePdf"
                            type="checkbox"
                            :id="`pdf-${report.key}`"
                            v-model="report.pdf"
                            @click="isDirty = true"
                        />
                    </div>
                </div>



                <div style="color:red;font-size:10pt;text-align:center">
                    {{ errorMessage }}
                </div>
                <div class="new-item-button-bar">
                    <button class="administrator-button new-item-button" @click="save" v-if="isDirty">
                        Save
                    </button>
                    <button class="administrator-button button-cancel new-item-button" @click="onCancel">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { getCurrentInstance } from "@vue/runtime-core";
import apiSettings from "@/api/apiSettings";
import apiUser from "@/api/apiUser";

export default {
    //props: ["title", "okText", "minLength", "maxLength"],
    setup(props, { emit }) {
        const emitter = getCurrentInstance().appContext.app.config.globalProperties.emitter;
        const refInput = ref(null);
        const errorMessage = ref("");
        const isDirty = ref(false);
        const fetching = ref(false);

        const model = ref([]);
        const users = ref(null);

        const onCancel = () => {
            emit("on-cancel");
        };

        const save = async () => {
            errorMessage.value = "";

                        
            if (model.value.userId.length == 0) {
                errorMessage.value = `User not selected`;
                return;
            }            
                        
            try {
                emitter.emit("server-call-start", "Saving...");
                await apiSettings.saveReportEmailSettings(model.value)
                isDirty.value = false;                
            } catch (err) {
                emitter.emit("show-alert", ["Error saving data", err]);
            }
            emitter.emit("server-call-stop");
        };

        const clearError = () => {
            errorMessage.value = "";
        };

        onMounted(async () => {
            model.value = [];            
            // refInput.value.focus();    
            await getData();
        });


        const getData = async () => {
            try {
                emitter.emit("server-call-start", "Loading...");
                fetching.value = true
                model.value = await apiSettings.getReportEmailSettings()
                users.value = await apiUser.getActiveUsers();
                isDirty.value = false;                
            } catch (err) {
                emitter.emit("show-alert", ["Error loading data", err]);
            }
            emitter.emit("server-call-stop");
            fetching.value = true
        }

        const processKeyPress = (event) => {
            if (event.keyCode === 13) save();
            if (event.keyCode === 27) onCancel();
        };

        return { 
            onCancel, 
            refInput, 
            save,             
            errorMessage, 
            clearError, 
            processKeyPress,
            model,
            isDirty,
            fetching,
            users
     };
    }
};
</script>

<style scoped>
/* @media (orientation: landscape) { */
@media (pointer: fine), (pointer: none) {
    .new-item {
        display: flex;
        flex-direction: column;
        position: absolute;
        position: absolute;
        top: 8%;
        left: 50%;
        transform: translateX(-50%);
        width: 800px;
        height: 800px;

        background: var(--main-background);
        border-radius: 10px;
        padding: 30px;
        border: 1px solid var(--card-body-border);
    }

    .item-input {
        width: 300px;
    }

    .tenant-input-container {
        display: flex;
        justify-content: space-between;
        margin: 10px;
    }
}

/* @media (orientation: portrait) { */
@media (pointer: coarse)  {    
    .new-item {
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 20%;
        left: 5%;
        /* margin-top: -75px; */
        /* margin-left: -210px; */
        width: 80vw;
        height: 170px;
        background: var(--main-background);
        border-radius: 10px;
        /* padding: 30px; */
        border: 1px solid var(--card-body-border);
    }

    .item-input {
        width: 70vw;
    }

    .tenant-input-container {
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        margin: 10px;
        flex-wrap: wrap;
    }
}

.new-item-button-bar {
    display: flex;
    justify-content: flex-end;
    padding: 5px;
    margin: 0px;
}

.new-item-button {
    /* background-color: cornflowerblue; */
    /* color: var(--button-color); */
    padding: 10px;
    margin-right: 10px;
    /* width: 125px; */
    /* cursor: pointer; */
}

.tenant-item {
    width: 500px;
    min-width: 100px;
}





.report-container {
    width: 100%;    
    height: 600px;
    overflow-y: auto;
    border: 1px solid #ccc;
    border-radius: 8px;
    background: #fff;
    margin: 0 auto;
}

.report-header,
.report-row {
    display: grid;
    grid-template-columns: 1fr 70px 70px;
    align-items: center;
    padding: 10px 12px;
    border-bottom: 1px solid #eee;
}

.report-header {
    font-weight: bold;
    background: #f5f5f5;
    position: sticky;
    top: 0;
    z-index: 1;
}

.report-row:last-child {
    border-bottom: none;
}

.report-row input {
    justify-self: center;
}
</style>
